import "core-js/modules/es.object.assign.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx } from "react/jsx-runtime";
export default function ChatMeetupMessageItem(props) {
  return _jsx("p", __assign({
    className: "chat-message-list__unsupported-message"
  }, {
    children: "\u6536\u5230\u4E00\u6761\u4E00\u8D77\u73A9\u6D88\u606F\uFF0C\u8BF7\u6253\u5F00APP\u8FDB\u884C\u67E5\u770B"
  }), void 0);
}